export default "__VITE_ASSET__f974b290__"